export default {
  setUserAvatarUrl(state, url) {
    state.userAvatarUrl = url
  },
  setSession(state, session) {
    state.session = session
    if (session) {
      localStorage.setItem('kintsu-session', JSON.stringify(session))
    } else {
      localStorage.removeItem('kintsu-session')
    }
  },
  setToken(state, token) {
    state.token = token
    if (token) {
      localStorage.setItem('kintsu-token', token)
    } else {
      localStorage.removeItem('kintsu-token')
    }
  },
  setShowSurvey(state, show) {
    state.showSurvey = show
  },
  // setPharmaceuticalDomainConfig(state, token) {
  //   const domain = location.hostname
  //   const decodedToken = jwt_decode(token)

  //   if (
  //     state.pharmaceuticalDomainConfig.PHARMACEUTICAL_ID === decodedToken.pharmaceuticalId ||
  //     !decodedToken.pharmaceuticalId
  //   ) {
  //     return
  //   }

  //   state.pharmaceuticalDomainConfig = utils.parsePharmaceuticalDomainConfig(decodedToken, domain)
  // },
  // setDefaultHomePage(state, defaultHomePage) {
  //   state.defaultHomePage = defaultHomePage
  // },
  // setCurrentHomePage(state, currentHomePage) {
  //   state.currentHomePage = currentHomePage
  //   if (currentHomePage) {
  //     localStorage.setItem('current-home-page', currentHomePage)
  //   } else {
  //     localStorage.removeItem('current-home-page')
  //   }
  // },
}
